<template>
  <div class="row">
    <!-- responsive layout -->
    <div :class="mobile ? 'container' : 'col s10 offset-s3'">
      <!-- level rows -->
      <div
        v-for="level in $store.getters.getInfo"
        :key="level.level"
        class="row"
        style="margin-top: 40px"
      >
        <h6>Level {{ level.level }}</h6>
        <!-- lesson box -->
        <div v-for="lesson in level.lessons" :key="lesson.lesson">
          <div
            data-target="lessonModal"
            @click="$store.commit('setLevelLesson', { level: level.level, lesson: lesson.lesson })"
            class="col s1 center white-text box"
            :class="$store.getters.getUser.role === 'admin' || lessonBox.level > level.level || lessonBox.level == level.level && lessonBox.lesson > lesson.lesson ? 'green modal-trigger' : lessonBox.level == level.level && lessonBox.lesson == lesson.lesson  ? 'amber modal-trigger' : lessonBox.level == level.level ? 'red': 'grey'"
            :style="$store.getters.getUser.role == 'admin' ? { 'cursor': 'pointer' } : lessonBox.level < level.level || lessonBox.level == level.level && lessonBox.lesson < lesson.lesson  ? { 'cursor': 'not-allowed' } : { 'cursor': 'pointer' }"
          >
            <i
              class="material-icons"
              :style="$store.getters.getUser.role == 'admin' ? { 'cursor': 'pointer' } : lessonBox.level < level.level || lessonBox.level == level.level && lessonBox.lesson < lesson.lesson  ? { 'cursor': 'not-allowed' } : { 'cursor': 'pointer' }"
            >{{ $store.getters.getUser.role === 'admin' || lessonBox.level > level.level || lessonBox.level == level.level && lessonBox.lesson > lesson.lesson ? 'check' : lessonBox.level == level.level && lessonBox.lesson == lesson.lesson ? 'person_pin_circle' : lessonBox.level == level.level ? 'close' : 'remove' }}</i>
          </div>
        </div>
      </div>
    </div>

    <!-- modal for select lesson -->
    <div id="lessonModal" class="modal modal-fixed-footer">
      <div class="modal-content">
        <!-- show selected level -->
        <h4>Level {{ $store.getters.getLevelLesson.level }}</h4>
        <hr />
        <form
          @submit.prevent="$router.push({name: 'lesson', params: { 
          level: $store.getters.getLevelLesson.level,
           lesson: $store.getters.getLevelLesson.lesson 
        }})"
        >
          <!-- select level -->
          <div class="row">
            <div class="input-field col s12">
              <select
                class="browser-default"
                v-model="$store.getters.getLevelLesson.level"
                required
              >
                <option value disabled selected>Select Level</option>
                <option
                  v-for="level in $store.getters.getUser.role === 'admin' ? $store.getters.getInfo : $store.getters.getUser.level"
                  :key="level.level || level"
                  :value="level.level || level"
                >Level {{ level.level || level }}</option>
              </select>
            </div>
          </div>
          <!-- select lesson -->
          <div class="row">
            <div class="input-field col s12">
              <select
                class="browser-default"
                v-model="$store.getters.getLevelLesson.lesson"
                required
              >
                <option value disabled selected>Select Lesson</option>
                <option
                  v-for="(lesson, index) in $store.getters.getUser.role === 'admin' || $store.getters.getUser.level > $store.getters.getLevelLesson.level ? lessons : $store.getters.getUser.level == $store.getters.getLevelLesson.level && $store.getters.getInfo[this.$store.getters.getLevelLesson.level - 1].lessons.length < $store.getters.getUser.lesson ? $store.getters.getInfo[this.$store.getters.getLevelLesson.level - 1].lessons.length : $store.getters.getUser.lesson"
                  :key="lesson.lesson || lesson"
                  :value="lesson.lesson || lesson"
                >{{ lesson.name || lessons[index] ? lessons[index].name : '' }}</option>
              </select>
            </div>
          </div>
          <!-- submit button -->
          <div class="row">
            <div class="input-field col s12">
              <div class="center">
                <button
                  class="btn indigo"
                  :class="$store.getters.getLevelLesson.level && $store.getters.getLevelLesson.lesson ? 'modal-close' : ''"
                >Start</button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- modal footer -->
      <div class="modal-footer">
        <!-- close button -->
        <a href="#!" class="modal-close btn-flat">Close</a>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  created() {
    $(document).ready(() => $(".modal").modal());
  },
  computed: {
    mobile() {
      return window.innerWidth < 992;
    },
    lessons() {
      return this.$store.getters.getInfo[
        this.$store.getters.getLevelLesson.level - 1
      ]
        ? this.$store.getters.getInfo[
            this.$store.getters.getLevelLesson.level - 1
          ].lessons
        : 0;
    },
    lessonBox() {
      return {
        level: this.$store.getters.getUser.level,
        lesson: this.$store.getters.getUser.lesson
      };
    }
  }
};
</script>


<style scoped>
.box {
  padding: 10px 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue